var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 2.333 4.2 4.2C21-.817 28.816 7 21.466 9.8l4.2 4.2-4.2 4.2c-2.8-7.35-10.616.466-3.266 3.266l-4.2 4.2-4.2-4.2C7 28.816-.817 21 6.533 18.2l-4.2-4.2 4.2-4.2c2.8 7.35 10.617-.467 3.267-3.267z"
  })));
};
export default SvgPuzzle;